export default {
  airdropPool: {
    4689: '0xdCBed258C93417B635eF9c24EA59Fc40d78D3fD8',
  },
  zoom: {
    56: '0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6',
    97: '',
    4689: '0xf87aed04889a1dd0159d9C22B0D57b345Ab16dDD',
    4690: '0x1839b86c43dfc8bb0a9553742ceaa15303b73872',
  },
  masterChef: {
    97: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    56: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
    4689: '0x1ba725d2ba56482f11fee3642f1c739d25018e4d',
    4690: '0xF7a316C9410269C6f56D464f9491916F7f117b2E',
  },
  masterChefV1: {
    4689: '0x92F1a54835436Ad1858018f11d017fCE31756C17',
  },
  zoomV1: {
    4689: '0x86702a7f8898B172de396eB304d7D81207127915',
  },
  lottery: {
    4689: '0x743eAE3D00CA22d62276D245689f8a11257265a7',
    4690: '0x28e4380B6639d5BC325fF6d0CD55858d33F29afA',
  },
  lotteryNFT: {
    4689: '0x68f4a9DC347a4325f15de0827591490AdD811b9a',
    4690: '0x23c5C735D8f5395E7506Da7768feAB39CbCEE453',
  },
  mulltiCall: {
    56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    97: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
    4689: '0xACCE294bf7D25Fe8C5C64Ae45197d3878F68403b',
    4690: '0x6AACfED704A1E5E57602f843ceBBfd107aE44077',
  },
  ioETH: {
    4689: '0x0258866edaf84d6081df17660357ab20a07d0c80',
  },
  ioBUSD: {
    4689: '0xacee9b11cd4b3f57e58880277ac72c8c41abe4e4',
  },
  bnb: {
    4689: '0x97e6c48867fdc391a8dfe9d169ecd005d1d90283',
  },
  ioUSDC: {
    4689: '0x3b2bf2b523f54c4e454f08aa286d03115aff326c',
  },
  'BUSD-bsc': {
    4689: '0x84abcb2832be606341a50128aeb1db43aa017449',
  },
  vita: {
    4689: '0xb8744ae4032be5e5ef9fab94ee9c3bf38d5d2ae0',
  },
  cyc: {
    4689: '0x4d7b88403aa2f502bf289584160db01ca442426c',
  },
  ioUSDT: {
    4689: '0x6fbcdc1169b5130c59e72e51ed68a84841c98cd1',
  },
  busd: {
    4690: '0x7b1cF44B0b2a8fD81F47e6e27c8E2862b366280f',
    4689: '0x84ABcb2832bE606341a50128AEB1DB43AA017449',
  },
  tkn: {
    4690: '0x834ca9DB362E9ee31Dd32EFD0D8D8335d55E26Da',
    4689: '0x5A8EB56c2d98FE753C967fe13d471d67FC6EA732',
  },
  tkn2: {
    4690: '0x2180d5bD2c30F9dD83cf862C970D642445b8085F',
    4689: '',
  },
  wiotx: {
    4690: '0xff5fae9fe685b90841275e32c348dc4426190db0',
    4689: '0xa00744882684c3e4747faefd68d283ea44099d03',
  },
  pointAridrop: {
    4690: '0xfcf34955FB71115B9bfE327df655788F62A01d3a',
    4689: '0xc0163F7bB39baC3148A3D760c2Cb852113C3299e',
  },
  gfs: {
    4689: '0x5d0f4ca481fd725c9bc6b415c0ce5b3c3bd726cf',
  },
  metx: {
    4689: '0x4752456e00def6025c77b55a88a2f8a1701f92f9',
  },
  gft: {
    4689: '0x17df9fbfc1cdab0f90eddc318c4f6fcada730cf2',
  },
  mcn: {
    4689: '0x3fe04320885e6124231254c802004871be681218',
  },
  wbtc: {
    4689: '0xc7b93720f73b037394ce00f954f849ed484a3dea',
  },
  mai: {
    4689: '0x3f56e0c36d275367b8c502090edf38289b3dea0d',
  },
  ciotx: {
    4689: '0x99b2b0efb56e62e36960c20cd5ca8ec6abd5557a',
  },
}
